import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import Popover from '@mui/material/Popover';
import React from 'react';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

interface WithConfirmationProps {
  children: JSX.Element;
  message?: string;
  onConfirm: () => void;
}

function WithConfirmation(props: WithConfirmationProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <span onClick={handleClick}>{props.children}</span>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <Typography sx={(theme) => ({ padding: theme.spacing(2) })}>
          {props.message || 'Are you sure?'}
        </Typography>
        <Grid container>
          <Grid>
            <Button onClick={handleClose}>
              <Typography variant="caption">Cancel</Typography>
            </Button>
          </Grid>
          <Grid>
            <Button onClick={props.onConfirm}>
              <Typography variant="caption">OK</Typography>
            </Button>
          </Grid>
        </Grid>
      </Popover>
    </div>
  );
}

export default WithConfirmation;
